import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class MeetingType extends Enum {
  key!: string;
  value!: string;
  subTitle!: string;
  description!: string;
  lockedDescription!: string;

  static BASIC_SUPPORT: MeetingType = {
    key: 'basic_support',
    get value(): string {
      return Lang.t('meeting.type-support');
    },
    get subTitle(): string {
      return Lang.t('meeting.subtitle-support');
    },
    get description(): string {
      return Lang.t('meeting.description-support');
    },
    get lockedDescription(): string {
      return Lang.t('meeting.description-support');
    }
  };

  static FREE_CONSULT: MeetingType = {
    key: 'free_consult',
    get value(): string {
      return Lang.t('meeting.type-free-consult');
    },
    get subTitle(): string {
      return Lang.t('meeting.subtitle-free-consult');
    },
    get description(): string {
      return Lang.t('meeting.description-free-consult');
    },
    get lockedDescription(): string {
      return Lang.t('meeting.description-free-consult');
    }
  };

  // Refers to planning consult
  static REFERRAL_CONSULT: MeetingType = {
    key: 'referral_consult',
    get value(): string {
      return Lang.t('meeting.type-referral-consult');
    },
    get subTitle(): string {
      return Lang.t('meeting.subtitle-free-consult');
    },
    get description(): string {
      return Lang.t('meeting.description-free-consult');
    },
    get lockedDescription(): string {
      return Lang.t('meeting.description-free-consult');
    }
  };

  static REFERRAL_CONSULT_SETTLEMENT: MeetingType = {
    key: 'referral_consult_settlement',
    get value(): string {
      return Lang.t('meeting.type-referral-consult');
    },
    get subTitle(): string {
      return Lang.t('meeting.subtitle-free-consult');
    },
    get description(): string {
      return Lang.t('meeting.description-free-consult');
    },
    get lockedDescription(): string {
      return Lang.t('meeting.description-free-consult');
    }
  };

  static SETTLEMENT_CONSULT: MeetingType = {
    key: 'settlement_consult',
    get value(): string {
      return Lang.t('meeting.type-free-consult');
    },
    get subTitle(): string {
      return Lang.t('meeting.subtitle-free-consult');
    },
    get description(): string {
      return Lang.t('meeting.description-free-consult');
    },
    get lockedDescription(): string {
      return Lang.t('meeting.description-free-consult');
    }
  };

  static INTAKE: MeetingType = {
    key: 'intake',
    get value(): string {
      return Lang.t('meeting.type-intake');
    },
    get subTitle(): string {
      return Lang.t('meeting.subtitle-intake');
    },
    get description(): string {
      return Lang.t('meeting.description-intake');
    },
    get lockedDescription(): string {
      return Lang.t('meeting.description-intake');
    }
  };

  static GUIDANCE: MeetingType = {
    key: 'guidance',
    get value(): string {
      return Lang.t('meeting.type-guidance');
    },
    get subTitle(): string {
      return Lang.t('meeting.subtitle-guidance');
    },
    get description(): string {
      return Lang.t('meeting.description-guidance');
    },
    get lockedDescription(): string {
      return Lang.t('meeting.guidance-meeting-locked-description');
    }
  };

  static WILL_REVIEW: MeetingType = {
    key: 'will_review',
    get value(): string {
      return Lang.t('meeting.type-will-review');
    },
    get subTitle(): string {
      return Lang.t('meeting.subtitle-will-review');
    },
    get description(): string {
      return Lang.t('meeting.description-will-review');
    },
    get lockedDescription(): string {
      return Lang.t('meeting.description-will-review');
    }
  };

  static ANNUAL_REVIEW: MeetingType = {
    key: 'annual_review',
    get value(): string {
      return Lang.t('meeting.annual-review');
    },
    get subTitle(): string {
      return Lang.t('meeting.subtitle-annual-review');
    },
    get description(): string {
      return Lang.t('meeting.description-annual-review');
    },
    get lockedDescription(): string {
      return Lang.t('meeting.annual-review-meeting-locked-description');
    }
  };

  static WILL_NOTARIZATION: MeetingType = {
    key: 'will_notarization',
    get value(): string {
      return Lang.t('meeting.type-notarization');
    },
    get subTitle(): string {
      return Lang.t('meeting.subtitle-will-notarization');
    },
    get description(): string {
      return Lang.t('meeting.description-notarization');
    },
    get lockedDescription(): string {
      return Lang.t('meeting.description-notarization');
    }
  };

  static PROTECTION_MANDATE_NOTARIZATION: MeetingType = {
    key: 'protection_mandate_notarization',
    get value(): string {
      return Lang.t('meeting.type-protection-mandate-notarization');
    },
    get subTitle(): string {
      return Lang.t('meeting.subtitle-protection-mandate-notarization');
    },
    get description(): string {
      return Lang.t('meeting.description-notarization');
    },
    get lockedDescription(): string {
      return Lang.t('meeting.description-notarization');
    }
  };

  static WILL_AND_PROTECTION_MANDATE_NOTARIZATION: MeetingType = {
    key: 'will_and_protection_mandate_notarization',
    get value(): string {
      return Lang.t('meeting.type-notarization');
    },
    get subTitle(): string {
      return Lang.t('meeting.subtitle-will-and-protection-mandate-notarization');
    },
    get description(): string {
      return Lang.t('meeting.description-notarization');
    },
    get lockedDescription(): string {
      return Lang.t('meeting.notarization-meeting-locked-description');
    }
  };

  static getBookableTypesOutsideOfEstates(): string[] {
    return [MeetingType.REFERRAL_CONSULT.key, MeetingType.REFERRAL_CONSULT_SETTLEMENT.key];
  }
}
